import React from 'react';
import { motion } from 'framer-motion';
import { SectionEyebrow } from './SectionEyebrow';
const spreads = [{
  chapter: 'Día 07',
  title: 'El espejo de tu autoestima',
  text: '¿Qué ves cuando te miras sin los filtros de las expectativas ajenas? Hoy comenzamos a desmantelar las mentiras que te contaste sobre tu propio valor.'
}, {
  chapter: 'Día 15',
  title: 'Volver a tu feminidad',
  text: 'La verdadera fuerza femenina no grita, sostiene. Aprender a recibir es el acto de vulnerabilidad más poderoso que puedes regalarte.'
}, {
  chapter: 'Día 22',
  title: 'Límites desde el amor',
  text: 'Un límite no es un muro para alejar a los demás, es una puerta que define cómo quieres ser amada. Si te cuesta ponerlos, es porque temes perder.'
}];
export function VistaPorDentro() {
  return <section className="py-24 md:py-32 px-6 bg-card overflow-hidden" data-id="element-268">
      <div className="container max-w-[1200px] mx-auto" data-id="element-269">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-270">
          <SectionEyebrow text="Un vistazo por dentro" className="mb-6" data-id="element-271" />
          <h2 className="text-4xl md:text-5xl text-foreground" data-id="element-272">
            Páginas que{' '}
            <span className="italic text-muted-foreground" data-id="element-273">transforman</span>
          </h2>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-12" data-id="element-274">
          {spreads.map((spread, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30,
          rotate: index === 1 ? 0 : index === 0 ? -2 : 2
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="bg-[#FAF6F0] w-full max-w-[320px] aspect-[3/4] p-8 rounded-sm shadow-book border border-white flex flex-col relative" data-id="element-275">
              {/* Subtle paper texture */}
              <div className="absolute inset-0 opacity-[0.03] mix-blend-multiply pointer-events-none" style={{
            backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
          }} data-id="element-276"></div>

              <div className="flex-grow flex flex-col justify-center text-center relative z-10" data-id="element-277">
                <p className="text-[10px] uppercase tracking-widest text-accent mb-4" data-id="element-278">
                  {spread.chapter}
                </p>
                <div className="w-12 h-[1px] bg-accent/30 mx-auto mb-6" data-id="element-279"></div>
                <h4 className="font-serif text-2xl text-foreground mb-6 leading-tight" data-id="element-280">
                  {spread.title}
                </h4>
                <p className="text-sm text-muted-foreground font-light leading-relaxed italic" data-id="element-281">
                  "{spread.text}"
                </p>
              </div>

              {/* Page number hint */}
              <div className="absolute bottom-6 left-0 right-0 text-center" data-id="element-282">
                <span className="text-[9px] text-muted-foreground/40 font-serif" data-id="element-283">
                  {index * 15 + 42}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}